import React from "react";
import { DPNetEarningsFile } from "Shared/types/NetEarnings";
import { TableRow, TableCell, Link, Button } from "@material-ui/core";
import pretty from "Shared/pretty";
import Formatting from "Modules/DataExchange/Formatting";
import { DPPermissionGate } from "Components/DP";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { useHistory } from "Hooks/useRouter";

export interface NetEarningsTableRowProps {
  netEarningsFile: DPNetEarningsFile,
  disablePayrollAnomaly?: boolean;
}

const NetEarningsTableRow = (props: NetEarningsTableRowProps) => {
  const {
    creator,
    attachment,
    status,
    createdAt,
    id,
    supportsAnomalyReport,
  } = props.netEarningsFile;

  const history = useHistory();

  const fullName = Formatting.dataExchangeFullName(
    creator.firstName || "",
    creator.lastName || ""
  );

  const goToPayrollAnomalyPage = () => {
    history.push({
      pathname: InternalRoutes.netEarningsAnomalyReport.replace(":id", id)
    });
  };

  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>{fullName}</TableCell>
      <TableCell>
        {pretty.file(attachment?.path || "").fileName}
      </TableCell>
      <TableCell>{pretty.titleizeWord(status)}</TableCell>
      <DPPermissionGate permissionKeys={["canViewGrossEarnings"]}>
        <TableCell>
          <Link href={attachment?.url || "#"} download>
            Download
          </Link>
        </TableCell>
        {!props.disablePayrollAnomaly && (
          <TableCell>
            {supportsAnomalyReport && (
              <Button onClick={goToPayrollAnomalyPage}>
                View Report
              </Button>
            )}
          </TableCell>
        )}
      </DPPermissionGate>
    </TableRow>
  );
};

export default NetEarningsTableRow;
